import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_PATIENT_REGISTER } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

// ✅ Create AsyncThunk for patient registration
export const registerPatient = createAsyncThunk(
  ACTION_PATIENT_REGISTER.register_patient,
  async (data, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.patientRegistration}`,
        data,
      );
      // ✅ Handle success
      if (response?.data?.status === true || response?.status === 200) {
        const message = getLocalizedMessage(response, i18n);
        toast.success(`${message} - OTP: ${response?.data?.data?.otp}`);
        return response.data;
      } else {
        const message = getLocalizedErrorMessage({ response }, i18n);
        toast.error(message);
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Error in Patient Register:", error);
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
